module.exports = __webpack_public_path__ + "img/btn3.8829196f.png";